// Dashboard Events translations (pt-BR), loaded into dashboard.events by ./pt-BR.js
module.exports = {
  label: "Eventos",
  summary: require('./events/pt-BR.summary.js'),
  evolution: require('./events/pt-BR.evolution.js'),
  categories: require('./events/pt-BR.categories.js'),
};
